/* eslint-disable react-hooks/exhaustive-deps */
import { each, get, isEmpty } from "lodash-es";
import React, { useEffect, useState } from "react";
import { getIndustryCodes } from "../../apis/code";
import { postAccounts, putAccounts } from "../../apis/companies/account";
import Form from "../../components/Form";
import Modal, { ModalHeader, ModalTab } from "../../components/Modal";
import { BANK_DATA } from "../../constants/BANK_DATA";
import { CLIENT_COMPANY_TYPES, CLIENT_TYPES } from "../../constants/CLIENT";
import useForm from "../../hooks/useForm";
import systemAlert from "../../utils/systemAlert";
import { findModeLabel } from "../../utils/mode";
import BondDebt from "../../components/Client/BondDebt";
import { getDay } from "../../utils/date";
import { getBondDebtsClientsSumaaries } from "../../apis/bond-debts";
import { getParams as getUtilParams } from "../../utils/params";
import { useSelector } from "react-redux";

// import useForm from "../../hooks/useForm";
const filterParams = {
  range: {
    trDate: [getDay(7), getDay()]
  }
};
const Client = (props) => {
  const {
    selectedClient, open, setOpen, setSelectedClient, submit, permission,
    defaultAddForm = {}, addAccountSubmit = () => { }
  } = props;

  const [mode, setMode] = useState('create');
  const [activeTab, setActiveTab] = useState(0);
  const [fields, setFields] = useState([]);
  const [industryCodes, setIndustryCodes] = useState([]);
  const [debtSubmmaryData, setDebtSubmmaryData] = useState(null);
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );

  const defaultForm = {
    code: "",// 거래처 코드
    name: "", // 거래처명
    type: CLIENT_TYPES[0].value, // 0: 사업자, 1: 개인, 2: 외국인
    sep: CLIENT_COMPANY_TYPES[0].value, // 0: 법인, 1: 개인
    ceoName: "",  // 대표자 명
    email: "", // 이메일
    comNum: "", // 사업자 등록 번호
    businessLicenseFile: [], // 사업자등록증 파일
    regNum: "", // 법인 등록 번호
    sectNum: "", // 종사업자 번호
    mobile: "", // 전화번호
    currency: "KRW", // 통화
    fax: "", // 팩스

    zipCode: "", // 우편 번호
    address: "", // 주소
    addressDetail: "", // 상세 주소

    industryType: "", // 업태
    industrySect: "", // 업종
    industryStCode: "", // 업종코드

    managerName: "", // 담당자 명
    managerPart: "", // 담당자 부서
    bankName: "", // 은행명
    bankCode: "", // 은행코드
    bankAccount: "", // 계좌번호
    taxEmail1: "",  // 세금계산서 발행 이메일 주소1
    taxEmail2: "", // 세금계산서 발행 이메일 주소2
    // bankAccountType: "", 
    ...defaultAddForm,
  };

  const _setIndustryCodes = async () => {

    if (isEmpty(industryCodes)) {
      const resIndustryCodes = await getIndustryCodes();
      const _industryCodes = resIndustryCodes.data.industryCodes.map((industry) => ({
        label: `${industry.type} > ${industry.sect} (${industry.code})`,
        value: industry.stCode,
        industry,
      }));
      setIndustryCodes(_industryCodes);
    }
    setFields([
      [
        {
          isHide: () => activeTab !== 0,
          title: "거래처명", key: "name", type: "input", required: true,
        },
        {
          isHide: () => activeTab !== 0,
          title: "거래처코드", key: "code", type: "input", required: true,
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: "구분",
          key: "type",
          type: "radio",
          options: {
            list: CLIENT_TYPES,
          },
          onChanged: ({ form }) => {
            if (form.type !== '0') {
              setForm({
                ...form,
                comNum: '',
                sep: '1'
              });
            }
          },
          required: true,
        },
        {
          isHide: () => activeTab !== 0,
          title: "회사구분",
          key: "sep",
          type: "radio",
          options: {
            list: CLIENT_COMPANY_TYPES,
          },
          required: true,
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: "대표자명", key: "ceoName", type: "input",
        },
        {
          isHide: () => activeTab !== 0,
          title: "이메일",
          key: "email",
          type: "input",
          validators: ['email']
        },
      ],
      [

        {
          isHide: () => activeTab !== 0,
          title: "사업자등록번호",
          isDisabled: ({ form = {} }) => {
            return form && form.type !== "0";
          },
          // titlestyle: {
          //   lineHeight: '15px'
          // },
          key: "comNum",
          type: "input",
          validators: ['comNum']
        },
        {
          isHide: () => activeTab !== 0,
          title: "사업자등록증",
          // titlestyle: {
          //   lineHeight: '15px'
          // },
          isDisabled: ({ form = {} }) => {
            return form && form.type !== "0";
          },
          mode: 'create',
          key: "businessLicenseFile",
          type: "dropzone",
          // isSingle: true
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: <>법인등록번호/<br />대표자 주민번호</>,
          placeholder: '법인등록번호/ 대표자 주민번호 입력',
          titlestyle: {
            lineHeight: '15px'
          },
          key: "regNum",
          type: "input",
          validators: ['jumin'],
        },
        {
          isHide: () => activeTab !== 0,
          title: "종사업자번호",
          key: "sectNum",
          type: "input",
          min: 4,
          max: 4,
          validators: ['number']
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: "전화번호",
          key: "mobile",
          type: "input",
        },
        {
          isHide: () => activeTab !== 0,
          title: "팩스번호",
          key: "fax",
          type: "input",
        },
      ],
      [
        {
          isHide: () => activeTab !== 0,
          title: "주소", key: "",
          type: "address",
          className: 'full'
        },
      ],
      {
        isHide: () => activeTab !== 1,
        title: "업종",
        type: "search-select",
        className: "manager-form-search-select",
        defaultValue: industryCodes.filter(
          (opt) => opt.value === get(form, "industryType")
        ),
        options: {
          list: industryCodes,
          menuPlacement: "top",
        },
        onChange: (data) => {

          setForm({
            ...form,
            industryStCode: data.industry.code,
            industryType: data.industry.type,
            industrySect: data.industry.sect,
          });
        },
      },
      [
        {
          isHide: () => activeTab !== 1,
          title: "업종코드",
          type: 'text',
          key: 'industryStCode',
          className: 'font-size-13'
        },
        {
          isHide: () => activeTab !== 1,
          title: "업태",
          type: 'input',
          key: 'industryType',
          className: 'font-size-13'
        },
        {
          isHide: () => activeTab !== 1,
          title: "업종",
          type: 'input',
          key: 'industrySect',
          className: 'font-size-13'
        },
      ],

      [
        {
          isHide: () => activeTab !== 1,
          title: "담당자명",
          key: 'managerName',
          type: 'input'
        },
        {
          isHide: () => activeTab !== 1,
          title: "담당자 부서",
          key: 'managerPart',
          type: 'input'
        }
      ],
      [
        {
          isHide: () => activeTab !== 1,
          title: "계산서 메일1",
          key: "taxEmail1",
          type: "input",
          validators: ['email']
        },
        {
          isHide: () => activeTab !== 1,
          title: "계산서 메일2",
          key: "taxEmail2",
          type: "input",
          validators: ['email']
        },
      ],
      {
        isHide: () => activeTab !== 1,
        title: "은행",
        type: "search-select",
        className: "manager-form-search-select",
        defaultValue: BANK_DATA.filter(
          (bank) => bank.fcode === get(form, "bankCode")
        ),
        options: {
          list: BANK_DATA.map(b => ({
            ...b,
            label: b.name,
            value: b.fcode
          })),
          menuPlacement: "top",
        },
        onChange: (data) => {

          setForm({
            ...form,
            bankName: data.name,
            bankCode: data.fcode,
          });
        },
      },
      [
        {
          isHide: () => activeTab !== 1,
          title: "은행명",
          key: "bankName",
          type: "text",
        },
        {
          isHide: () => activeTab !== 1,
          title: "은행코드",
          key: "bankCode",
          type: "text",
        },
      ],
      {
        isHide: () => activeTab !== 1,
        title: "계좌번호",
        key: "bankAccount",
        type: "input",
      },

    ]);
  };

  useEffect(() => {
    _setIndustryCodes();
  }, [activeTab]);

  const tabList = [
    { label: "기본정보", action: setActiveTab },
    { label: "부가정보", action: setActiveTab },
    // ...(permissions.find(p => p.code === 'FUND_CLAIM_OBLIGATION')
    //   ? [{ label: "거래처별 채권채무", action: setActiveTab }]
    //   : []
    // )
  ];

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setActiveTab(0);
    if (mode !== 'create') {
      setSelectedClient(null);
    }
  };


  const getParams = (form) => {
    const params = {};
    each(form, (value, key) => {
      if (key === 'bankAccountType') {

      } else if (!isEmpty(value)) {
        params[key] = value;
      } else {
        if (mode !== 'create') {
          params[key] = null;
        }
      }
    });
    if (form.businessLicenseFile) {
      params.businessLicenseFile = JSON.stringify(form.businessLicenseFile);
    }

    return {
      ...params,
    };

  };
  const _submit = (form) => {

    let checkFile = true;
    each(form.businessLicenseFile, (item) => {
      const idx = Number(item);
      if (isNaN(idx) || idx <= 0) {
        checkFile = false;
      }
    });

    if (!checkFile) {
      systemAlert('첨부파일을 확인해 주세요.');
      return;
    }

    if (mode === 'create') {
      systemAlert(`"${form.name}" 거래처를 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              postAccounts(getParams(form))
                .then((res) => {
                  cancel();
                  if (submit) {
                    submit();
                  }

                  if (addAccountSubmit) {
                    addAccountSubmit(res.data);
                  }
                });
            }
          }
        ]
      });
    } else {
      systemAlert(`"${form.name}" 거래처를 수정하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '승인',
            onClick: () => {
              putAccounts(selectedClient.idx, getParams(form))
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });

    }
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setMode(isEmpty(selectedClient) ? 'create' : (permission.level > 1 ? 'modify' : 'view'));
    // setFormFields(task.fields)
    // debugger
    if (selectedClient) {
      selectedClient.type = String(selectedClient.type);
      selectedClient.sep = String(selectedClient.sep);

      setForm(selectedClient);
      setOriginForm(selectedClient);
      permissions.find(p => p.code === 'FUND_CLAIM_OBLIGATION') &&
        getBondDebtsData();
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedClient]);

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);


  const getBondDebtsData = () => {
    const params = getUtilParams({
      ...filterParams,
      clientIdxes: [30],
      type: "invoice"
    });


    getBondDebtsClientsSumaaries(params).then(res => {
      setDebtSubmmaryData(res?.data?.summaries[0]);
    }).catch(err => {
      console.error(err);
    });
  };

  return (
    <Modal
      isOpen={open}
      // isOpen={true}
      close={cancel}
    // {...mode === 'create' ? { close: cancel } : { toggle: cancel }}
    >
      <div className="client-write">
        <ModalHeader>{selectedClient && <>"{selectedClient.name}"</>} 거래처 정보 {findModeLabel(mode)}</ModalHeader>
        <ModalTab tabList={tabList} active={activeTab} />
        {activeTab === 2 && !isEmpty(debtSubmmaryData) ? (
          <BondDebt
            filterParams={filterParams}
            data={debtSubmmaryData}
            type={"invoice"}
          />
        ) : (
          <Form
            mode={mode}
            form={form}
            errors={errors}
            isRequiredShow={true}
            setForm={setForm}
            fields={fields}
            onChange={handleOnChange}
            cancelText={'닫기'}
            submitText={mode === 'create' ? '등록' : '수정'}
            submit={handleSubmit}
            cancel={cancel}
          />
        )}
      </div>
    </Modal>
  );
};

export default Client;
